import { OpenTo } from "@/generated-api";
import BadgeWithImage from "./BadgeWithImage";
import { useTranslation } from "@/hooks/useTranslation";
import { getTranslatedEnumLabel } from "@/lib/utils";
import { OPEN_TO_EMOJI_MAP } from "../onboarding/data-form/openToEmojiMap";

export default function OpenToBadges({ openTo }: { openTo: OpenTo[] }) {
  const t = useTranslation();

  return (
    <>
      {openTo.map((selection) => (
        <BadgeWithImage
          key={selection}
          image={OPEN_TO_EMOJI_MAP[selection]}
          title={getTranslatedEnumLabel(t, selection)}
        />
      ))}
    </>
  );
}
